import { useGetVipById } from '../hooks/useGetVipById';
import React, { forwardRef } from 'react';
import { VIPData, VIPForm } from './VIPForm';
import { useUpdateVip } from '../hooks/useUpdateVip';

type VIPFormEditProps = {
  editId: string;
  onSubmit: (data: VIPData) => void;
};

export const VIPFormEdit = forwardRef((props: VIPFormEditProps, ref) => {
  const { editId, onSubmit } = props;
  const { data, loading } = useGetVipById(editId);
  const { updateVip } = useUpdateVip();

  if (loading || !data) {
    return null;
  }

  const handleSubmit = async (formData: VIPData) => {
    const data = await updateVip(editId, formData);
    if (data) {
      onSubmit(data);
    }
  };

  return (
    <VIPForm
      ref={ref}
      initialData={data}
      onSubmit={handleSubmit}
    />
  );
});
